import { CampusMediaService } from 'services/client-api-wrapper';
import { getApiGatewayUrl } from 'kits/urlKit';

export const campusMediaService = new CampusMediaService(getApiGatewayUrl('media', 'default'));
